import { FreshdeskFaqsService } from './freshdesk-faqs.service';

export default angular
  .module('ng1-freshdesk-faqs', [])
  .value('freshdeskApiConfig', {
    apiHost: 'https://finodigital.freshdesk.com/api/v2',
    apiKey: 'Woj6a4zu9r5PKa8l1J7h'
  })
  .service('freshdeskFaqsService', FreshdeskFaqsService)
  .name;




// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-freshdesk-faqs/src/index.js